export default __webpack_public_path__ + "static/media/27.4d6c83be.png";